// Main Vars
require('./src/styles/utils/variables/_colors.scss');
require('./src/styles/utils/variables/_main.scss');
require('./src/styles/base/_typography.scss');
require('./src/styles/base/_reset.scss');
require('./src/styles/base/_spacing.scss');
require('./src/styles/layouts/_grid.scss');

function initGTM() {
  if (window.loadGTM === false || window.gtmDidInit) {
    return false;
  }

  window.gtmDidInit = true; // flag to ensure script does not get added to DOM more than once.
  const trackingLink = `https://www.googletagmanager.com/gtm.js?id=${process.env.GA_TRACKING_ID}`;

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = trackingLink;

  script.onload = () => {
    // eslint-disable-next-line no-undef
    dataLayer.push({
      // ensure PageViews are always tracked
      event: 'gtm.js',
      'gtm.start': new Date().getTime(),
      'gtm.uniqueEventId': 0,
    });
  };
  document.head.appendChild(script);

  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = trackingLink;
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  iframe.height = 0;
  iframe.width = 0;
  noscript.innerHTML += iframe.outerHTML;
  document.body.appendChild(noscript);
}

function initGTMOnEvent(event) {
  initGTM();
  event.currentTarget.removeEventListener(event.type, initGTMOnEvent); // remove the event listener that got triggered
}

exports.onClientEntry = () => {
  document.addEventListener('scroll', initGTMOnEvent);
  document.addEventListener('mousemove', initGTMOnEvent);
  document.addEventListener('touchstart', initGTMOnEvent, { passive: true });
};
